// Lives in its own module so guards.tsx can import the id WITHOUT statically
// importing FloorModal — that import drags the viewer HUD graph (FloorMap →
// three hooks → vendor-three, ~307KB) into the entry chunk of every page,
// landings included. guards.tsx lazy-loads the component instead.
export const FLOOR_MODAL_ID = "floor-modal";
